import { render, staticRenderFns } from "./CollectionCover.vue?vue&type=template&id=c2b35db6&scoped=true"
import script from "./CollectionCover.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCover.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CollectionCover.vue?vue&type=style&index=0&id=c2b35db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b35db6",
  null
  
)

export default component.exports